import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFigma12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconFigma12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.857 4.434A1.86 1.86 0 0 1 3 2.868C3 1.836 3.844 1 4.885 1h3.23C9.156 1 10 1.836 10 2.868c0 .656-.341 1.233-.857 1.566.516.333.857.91.857 1.566a1.877 1.877 0 0 1-1.885 1.868H8.08c-.493 0-.94-.187-1.276-.493v1.74c0 1.043-.863 1.885-1.911 1.885C3.854 11 3 10.166 3 9.132c0-.656.341-1.233.857-1.566A1.86 1.86 0 0 1 3 6c0-.656.341-1.233.857-1.566M6.805 6A1.27 1.27 0 0 0 8.08 7.264h.034A1.27 1.27 0 0 0 9.39 6a1.27 1.27 0 0 0-1.276-1.264H8.08A1.27 1.27 0 0 0 6.805 6m-.61-1.264h-1.31A1.27 1.27 0 0 0 3.61 6a1.27 1.27 0 0 0 1.272 1.264h1.314zm-1.31 3.132h-.004a1.27 1.27 0 0 0-1.272 1.264c0 .696.578 1.264 1.285 1.264.716 0 1.301-.575 1.301-1.28V7.867zm1.31-3.736h-1.31A1.27 1.27 0 0 1 3.61 2.868a1.27 1.27 0 0 1 1.276-1.264h1.31zm1.92 0h-1.31V1.604h1.31A1.27 1.27 0 0 1 9.39 2.868a1.27 1.27 0 0 1-1.276 1.264"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFigma12);
